import React from "react";
import { View, Text, Platform } from "react-native";
import StyleSheet from "react-native-media-query";

import commonStyle from "../../assets/styles/common-style";
import { theme } from "../../theme/theme";

interface ListHeadingProps {
  title: string;
  headerStyle?: "primary" | "secondary";
  page?: string;
}

const ListHeading: React.FC<ListHeadingProps> = ({
  title,
  headerStyle = "primary",
  page
}) => {
  return (
    <View
      dataSet={{ media: commonStyle.ids.rowFlex }}
      style={[
        commonStyle.styles.rowFlex,
        styles.listHeadingTop,
        headerStyle === "primary" && styles.primaryHeader,
      ]}
    >
      <Text
        style={[styles.headingText, styles.listHeadingTopText]}
        dataSet={{ media: ids.headingText }}
        testID={`${page}-page-${title.toLowerCase()?.replace(" ","-")}-label-heading`}
      >
        {title}
      </Text>
    </View>
  );
};

const { styles, ids } = StyleSheet.create({
  listHeadingTopText: {
    fontFamily: theme.fontFamily.robotoBold,
    fontSize: theme.fontsize.cs,
    color: theme.colors.white,
    ...Platform.select({
      web: {
        fontWeight: theme.fontweight.bold as any,
      },
    }),
  },
  primaryHeader: {
    backgroundColor: theme.colors.primaryDark,
    borderTopEndRadius: theme.radius.sm,
    borderTopLeftRadius: theme.radius.sm,
  },
  listHeadingTop: {
    backgroundColor: theme.colors.black + 50,
    padding: theme.spacing.ssm,
  },
  headingText: {
    color: theme.colors.white,
    paddingLeft: theme.spacing.xs,
  },
  WhiteText: {
    color: theme.colors.text.secondary,
    fontWeight: theme.fontweight.xlight as any,
    paddingLeft: theme.spacing.md,
    ...Platform.select({
      ios: {
        "@media (min-width: 200px)": { fontSize: theme.fontsize.cs },
        "@media (min-width: 385px)": { fontSize: theme.fontsize.cs },
        "@media (min-width: 700px)": { fontSize: theme.fontsize.md },
        "@media (min-width: 900px)": { fontSize: theme.fontsize.md },
        "@media (min-width: 1000px)": { fontSize: theme.fontsize.md },
        "@media (min-width: 1200px)": { fontSize: theme.fontsize.md },
      },
      android: {
        "@media (min-width: 200px)": {
          fontSize: theme.fontsize.cs,
          color: theme.colors.text.secondary,
        },
        "@media (min-width: 385px)": { fontSize: theme.fontsize.md },
        "@media (min-width: 700px)": { fontSize: theme.fontsize.md },
        "@media (min-width: 900px)": { fontSize: theme.fontsize.md },
        "@media (min-width: 1000px)": { fontSize: theme.fontsize.md },
        "@media (min-width: 1200px)": { fontSize: theme.fontsize.md },
      },
      web: {
        maxWidth: 1100,
        "@media (min-width: 200px)": { fontSize: theme.fontsize.cs },
        "@media (min-width: 385px)": { fontSize: theme.fontsize.md },
        "@media (min-width: 700px)": { fontSize: theme.fontsize.cs },
        "@media (min-width: 1000px)": { fontSize: theme.fontsize.cs },
        "@media (min-width: 1681px)": { fontSize: theme.fontsize.md },
      },
    }),
  },
});

export default ListHeading;
